import styled from 'styled-components';
import { generateMedia } from 'styled-media-query';

export default function TabbedServicesPanelThree() {
  return (
    <TabPanelContainer>
      <div className="tab-content">
        <div className="tab-top-content">
          <h1>We are localy owned business!</h1>
          <p>
            We are located in the beautiful south ends of the Guelph commons. We can take care of
            your pet here or we can come to your place!
          </p>
        </div>
      </div>
      <div
        className="map-container"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2893.8040775614036!2d-80.19476522340075!3d43.50642257110945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b84a16ee6fcbb%3A0x69a2c912f6dac9f6!2s152%20Farley%20Dr%2C%20Guelph%2C%20ON%20N1L%201M1!5e0!3m2!1sen!2sca!4v1753032760465!5m2!1sen!2sca"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </TabPanelContainer>
  );
}

const customMedia = generateMedia({
  xsPhone: '500px',
  phone: '760px',
  tablet: '800px',
  desktop: '1200px',
});

const TabPanelContainer = styled.div`
  background-image: linear-gradient(to right, #faeda2 0%, #faeda2 50%, #f0f0a2 50%);
  height: 62rem;
  width: 100%;
  position: relative;
  .tab-content {
    margin: 0 15%;
    .tab-top-content {
      display: grid;
      grid-template-rows: min-content min-content;
      gap: 0.25rem;
      margin-top: 0.25rem;
      h1 {
        font-size: 3rem;
        margin-top: 1.5rem;
      }
      p {
        grid-row: 2 / span 1;
        margin: 0;
      }
    }
  }
  .map-container {
    height: 70%;
  }

  ${customMedia.lessThan('phone')`
    height: 78rem;  
    iframe {
      width: 400px;
    }
  `}

  ${customMedia.greaterThan('tablet')`
    .map-container {
      height: 80%;
    }
  `};
`;
